<template>
  <b-modal
    :id="id"
    hide-footer
    hide-header
    hide-header-close
    centered
    no-close-on-esc
    no-close-on-backdrop
  >
    <div class="p-2 text-center">
      <div class="loading-icon mb-3">
        <img
          src="https://storage.googleapis.com/komerce/core/icon-popup-warning.png"
          alt="Mohon Tunggu"
          class="mx-auto"
          width="80px"
        >
      </div>
      <div class="mb-2">
        <h2 class="font-bold text-black text-2xl mb-2">
          Mohon Tunggu Beberapa Saat
        </h2>
        <p class="text-secondary">
          Mohon tunggu maksimal 1x24 jam, dan kamu bisa segera menggunakannya.
          Terima kasih atas kesabarannya
        </p>
      </div>
      <b-button
        variant="primary"
        block
        @click="$router.push({ name: 'dashboard-komship' })"
      >
        Oke
      </b-button>
    </div>
  </b-modal>
</template>

<script>
export default {
  props: {
    id: {
      type: String,
      default: 'modal-waiting-response',
    },
    message: {
      type: String,
      default:
        'Mohon tunggu maksimal 1x24 jam, dan kamu bisa segera menggunakannya. Terima kasih atas kesabarannya',
    },
  },
}
</script>

<style scoped>
.text-black {
  color: #333333;
}

.text-secondary {
  color: #6c757d;
}
</style>
